import queryString from 'query-string'
import 'whatwg-fetch'
import timelineData from './data/timeline_data'

const _getData = (url, params, slashParams = false) => {
    let _params = slashParams ?
        params.map(p => `/${p}`).join('') :
        queryString.stringify(params)

    return fetch(`${url}${_params}`);
}
const _postData = (url, params) => {
    return fetch(url, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: "POST",
        body: queryString.stringify(params)
    });
}
const jsonPipe = response => response.json();

const commentsApiRoot = 'https://z.ynet.co.il/mLong/Content/2017/TalkbackWS/api/Service/';
const CommentsApi = {
    like: articleId => _getData(`${commentsApiRoot}AddLike`, [articleId], true),
    dislike: articleId => _getData(`${commentsApiRoot}AddDislike`, [articleId], true),
    add: (author, title, content, articleId, parentId) =>
        _postData(`${commentsApiRoot}AddTalkback`, {
            authorName: author,
            title: title,
            content: content,
            articleId: articleId,
            parentId: parentId
        }),
    get: (articleId, bulkSize) =>
        _getData(
            `${commentsApiRoot}GetArticleTalkbacks`,
            [articleId, bulkSize],
            true).then(jsonPipe),
    getCount: articleId =>
        _getData(
            `${commentsApiRoot}GetTalkbackCount`,
            [articleId],
            true).then(jsonPipe)
}

const articlesApiRoot = './static/articles/';
const ArticlesApi = {
    get: articleId => {
        return _getData(`${articlesApiRoot}article${articleId}.html?v=3`)
            .then(response => response.text());
    },
    getVideoDetails: videoId =>
        _getData(`https://www.ynet.co.il/3rdparty/mobile/json/video/${videoId}/`)
            .then(jsonPipe)
}

const TimelineApi = {
    getData: () => {
        const text = timelineData;
        const arr = text.split('@');
        const _timelineItems = arr.map((text, idx) => {
            if (isNaN(text)) return undefined;
            const nextItem = arr[idx + 1];
            if (!nextItem) return undefined;
            return {
                year: text,
                description: nextItem.trim().replace(/ +/g, ' ')
            }
        }).filter(item => typeof item !== 'undefined');
        return _timelineItems;
    }
}
export {
    CommentsApi,
    ArticlesApi,
    TimelineApi
}


// WEBPACK FOOTER //
// ./src/api.js